module.exports = __webpack_public_path__ + "img/solomon-islands.85ba2391.svg";